// Mở một mục hộp "Việc cần xử lý" (chuông, thẻ Tổng quan): điều hướng tới `to` + `search` của mục. Riêng "n công việc quá
// hạn": notification-service đếm việc chưa xong có giờ hẹn < bây giờ, còn tab "Quá hạn" của Lịch hẹn chỉ gồm việc trước hôm
// nay (việc hôm nay đã qua giờ nằm ở "Hôm nay", giờ màu đỏ). Khi tôi không có việc quá hạn từ trước hôm nay ⇒ mọi việc của
// mục đều là việc hôm nay đã qua giờ ⇒ mở tab "Hôm nay" để danh sách chứa đúng các việc đó (tạm thời, tới khi hai service
// dùng chung một định nghĩa — xem báo cáo backend).
import { useCallback } from 'react';
import { useNavigate } from '@tanstack/react-router';
import { useQueryClient } from '@tanstack/react-query';
import type { InboxItem } from '@/entities/inbox';
import { taskCountsQuery } from '@/entities/task';
import { useCan } from '@/entities/viewer';

/** Search param đích của mục `task_overdue` theo số việc của tôi (null ⇒ giữ nguyên liên kết của mục). */
export function overdueLanding(search: Record<string, unknown>, counts: { today: number; overdue: number } | null | undefined): Record<string, unknown> {
  if (!counts || search.tab !== 'overdue') return search;
  return counts.overdue === 0 && counts.today > 0 ? { ...search, tab: 'today' } : search;
}

export function useOpenInboxItem() {
  const navigate = useNavigate();
  const qc = useQueryClient();
  const { staffId } = useCan();
  return useCallback(
    async (a: Pick<InboxItem, 'kind' | 'to' | 'search'>) => {
      if (!a.to) return;
      let search = (a.search ?? {}) as Record<string, unknown>;
      if (a.kind === 'task_overdue' && search.tab === 'overdue' && staffId) {
        try {
          search = overdueLanding(search, await qc.fetchQuery({ ...taskCountsQuery(staffId), staleTime: 0 }));
        } catch {
          /* không đọc được số việc ⇒ giữ liên kết của mục */
        }
      }
      void navigate({ to: a.to, search: search as never });
    },
    [navigate, qc, staffId],
  );
}
